import { genreOptions, regionOptions, yearOptions } from '@/mocks/catalog';

export interface FilterState {
  genre: string;
  region: string;
  year: string;
  sort: string;
}

interface FilterControlsProps {
  filters: FilterState;
  onChange: (patch: Partial<FilterState>) => void;
}

const SORT_OPTIONS = [
  { value: 'latest', label: '最新上映' },
  { value: 'rating', label: '评分最高' },
  { value: 'hot', label: '热度最高' },
];

const GROUP_LABEL = 'w-14 shrink-0 pt-1.5 text-sm text-foreground-500';
const chipBase =
  'px-3 py-1.5 rounded-md text-sm transition-colors whitespace-nowrap border';

function chipClass(active: boolean) {
  return active
    ? `${chipBase} bg-primary-500 border-primary-500 text-background-50 font-medium`
    : `${chipBase} border-transparent text-foreground-600 hover:bg-background-200 hover:text-foreground-900`;
}

export default function FilterControls({ filters, onChange }: FilterControlsProps) {
  return (
    <div className="space-y-1">
      <div className="flex gap-3 border-t border-background-200 py-3">
        <span className={GROUP_LABEL}>类型</span>
        <div className="flex flex-wrap gap-1.5">
          {genreOptions.map((option) => (
            <button
              key={option}
              type="button"
              onClick={() => onChange({ genre: option })}
              className={chipClass(filters.genre === option)}
            >
              {option}
            </button>
          ))}
        </div>
      </div>

      <div className="flex gap-3 border-t border-background-200 py-3">
        <span className={GROUP_LABEL}>地区</span>
        <div className="flex flex-wrap gap-1.5">
          {regionOptions.map((option) => (
            <button
              key={option}
              type="button"
              onClick={() => onChange({ region: option })}
              className={chipClass(filters.region === option)}
            >
              {option}
            </button>
          ))}
        </div>
      </div>

      <div className="flex gap-3 border-t border-background-200 py-3">
        <span className={GROUP_LABEL}>年份</span>
        <div className="flex flex-wrap gap-1.5">
          {yearOptions.map((option) => (
            <button
              key={option}
              type="button"
              onClick={() => onChange({ year: option })}
              className={chipClass(filters.year === option)}
            >
              {option}
            </button>
          ))}
        </div>
      </div>

      <div className="flex gap-3 border-t border-background-200 py-3">
        <span className={GROUP_LABEL}>排序</span>
        <div className="flex flex-wrap gap-1.5">
          {SORT_OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange({ sort: option.value })}
              className={chipClass(filters.sort === option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}